import cx from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React, { useContext, useState } from 'react'
import { primaryLinks } from '../../../content/menu'
import { neoskop } from '../../../content/neoskop'
import { PageContext } from '../../../context/PageContext'
import { curtainVariants, fadeScaleVariants, listItemVariants } from '../../animations/variants'
import Aside from '../Aside'
import AsideLink from '../AsideLink'
import AsideSection from '../AsideSection'
import AsideText from '../AsideText'
import PageLink from '../PageLink'
import SocialLinks from '../SocialLinks'
import useQuery from './query'
import './styles.scss'

const OffcanvasMenu = ({ location, lang }) => {
  const { offcanvasMenu } = useContext(PageContext)

  const query = useQuery()

  const [activeLink, setActiveLink] = useState(null)

  const getLinkImage = index => {
    const source = primaryLinks[index].imageSource

    return (
      <GatsbyImage
        image={query[source].childImageSharp.gatsbyImageData}
        alt="Neoskop - Agentur für digitale Kommunikation"
      />
    )
  }

  return (
    <AnimatePresence>
      {offcanvasMenu && (
        <motion.div
          className="offcanvas-menu"
          initial="initial"
          animate="visible"
          exit="hidden"
          variants={curtainVariants}
        >
          <AnimatePresence>
            {activeLink !== null && (
              <motion.div
                className="offcanvas-menu__image-container"
                key="image"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={fadeScaleVariants}
              >
                <AnimatePresence>
                  <motion.div
                    className="offcanvas-menu__image"
                    key={activeLink}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={fadeScaleVariants}
                  >
                    {getLinkImage(activeLink)}
                  </motion.div>
                </AnimatePresence>
              </motion.div>
            )}
          </AnimatePresence>
          <div className="offcanvas-menu__inner">
            <nav className="offcanvas-menu__nav">
              <ul className="offcanvas-menu__nav__list">
                {primaryLinks.map((link, index) => (
                  <motion.li
                    className={cx({
                      'offcanvas-menu__nav__list__item': true,
                      'is-active': location.pathname === link[lang].to
                    })}
                    key={index}
                    custom={index}
                    initial="initial"
                    animate="visible"
                    exit="hidden"
                    variants={listItemVariants}
                  >
                    <span>
                      <PageLink
                        to={link[lang].to}
                        active={location.pathname === link[lang].to ? true : false}
                        display="inline"
                        hoverEffect={false}
                      >
                        {link[lang].name}
                      </PageLink>
                    </span>
                  </motion.li>
                ))}
              </ul>
            </nav>
            <div className={cx({ 'offcanvas-menu__aside': true, 'is-visible': activeLink === null })}>
              <Aside>
                <AsideSection title="Get in Touch">
                  <AsideLink href={'tel:' + neoskop.contact.phone} kind="contact">
                    {neoskop.contact.phone}
                  </AsideLink>
                  <AsideLink href={'mailto:' + neoskop.contact.mail} kind="contact">
                    {neoskop.contact.mail}
                  </AsideLink>
                </AsideSection>
                <AsideSection title="Location">
                  <AsideText>
                    {neoskop.adress.street} {neoskop.adress.houseNumber} <br />
                    {neoskop.adress.zip} {neoskop.adress.city}
                  </AsideText>
                  <AsideLink href={neoskop.adress.googleMapUrl} _blank variant="secondary">
                    Zu Google Maps
                  </AsideLink>
                </AsideSection>
                <AsideSection title="Social">
                  <SocialLinks
                    links={[{ icon: 'instagram', to: neoskop.social.instagram.url }]}
                    color="white"
                    size="large"
                  />
                </AsideSection>
              </Aside>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

OffcanvasMenu.propTypes = {
  location: PropTypes.object,
  lang: PropTypes.string
}

export default OffcanvasMenu
